module.exports = __webpack_public_path__ + "img/img_kuang@2x.9bb23682.png";